// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
export const windowLocation = {
  setWindowLocationHRef(url) {
    window.location.href = url;
  },
};
